import { useCountdown } from '@nv/hooks'
import { useTranslation } from 'react-i18next'
import RenderTBD from './RenderTBD'
import styles from './CountdownTimerSmall.module.scss'

const CountdownTimerSmall = ({ countDownDate, status }) => {
  const { t } = useTranslation()
  const { days, hours, minutes, seconds } = useCountdown(countDownDate)

  const diffDate = new Date().getTime() - new Date(countDownDate).getTime()
  if (diffDate > 0) {
    return <RenderTBD status={status} size={'small'} layout={null} />
  }
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{t(`countdown.label.${status}`)}</div>

      <div className={styles['content']}>
        {days}
        <span className={styles['content__value']}>{t('countdown.time.short.days')}</span>
        {hours}
        <span className={styles['content__value']}>{t('countdown.time.short.hours')}</span>
        {minutes}
        <span className={styles['content__value']}>{t('countdown.time.short.mins')}</span>
        {seconds}
        <span className={styles['content__value']}>{t('countdown.time.short.sec')}</span>
      </div>
    </div>
  )
}

export default CountdownTimerSmall
